<template>
    <div class="">
        <question v-if="question.style.component == 'question'" v-for="(question, key) in questions" :key="'question_'+key" :index="key" :question="question"></question>
        <range v-if="question.style.component == 'range'" v-for="(question, key) in questions" :key="'question_'+key" :index="key" :question="question"></range>
    </div>
</template>
<script>

import Question from './question';
import Range from './range';

export default {
    props: [
        'questions'
    ],
    components: {
        Question,
        Range
    },
    data() {
        return {
            page: {
                questions: null
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/quiz-campaign/components/questions.vue